/*eslint perfectionist/sort-objects: "error"*/
/* eslint-disable no-multi-str */

export const enGb = {
  actualAmount: "Actual Amount",
  bvnkCopyLink: "Copy Link",
  bvnkCopyLinkForCustomer:
    "Copy and share this link with the customer to continue onboarding:",
  bvnkCryptoPayments: "Stablecoin Payments Onboarding",
  bvnkDescription: "Description",
  bvnkIndustry: "Industry",
  bvnkMonthlyVolume: "Monthly Expected Volume",
  bvnkOnboardingContactAdmin:
    "To start onboarding for this customer, please contact a Volt administrator.",
  bvnkOnboardingDescription:
    "Process onboarding to start receiving money in crypto.",
  bvnkOnboardingFailure: "Failed to start onboarding. Please try again.",
  bvnkOnboardingFormDescription:
    "Complete the form below to start the onboarding process.",
  bvnkOnboardingStatusActive:
    "Onboarding is complete and the customer is active.",
  bvnkOnboardingStatusInfoRequired:
    "Additional information is required to continue onboarding.",
  bvnkOnboardingStatusPending: "Onboarding is in progress.",
  bvnkOnboardingStatusPendingAgreements:
    "Customer needs to review and accept agreements to continue.",
  bvnkOnboardingStatusRejected:
    "Onboarding was rejected. Please review details and try again.",
  bvnkOnboardingStatusVerified:
    "Customer is verified and onboarding is complete.",
  bvnkOnboardingSuccess: "Onboarding started successfully.",
  bvnkOnboardingSuccessDescription:
    "Share the hosted agreement URL with the merchant to complete signing.",
  bvnkOnboardingUnknownStatus:
    "The onboarding status is currently unknown. Please contact your administrator for assistance.",
  bvnkUseCase: "Use Case",
  bvnkUseCaseEMBEDDED_FIAT_ACCOUNTS: "Embedded Fiat Accounts",
  bvnkUseCaseEMBEDDED_STABLECOIN_WALLETS: "Embedded Stablecoin Wallets",
  bvnkUseCaseSTABLECOIN_PAYOUTS: "Stablecoin Payouts",
  bvnkViewNextStep: "Continue to Next Step",
  cancel: "Cancel",
  close: "Close",
  confirmedAt: "Confirmed at",
  country: "Country",
  customerDetailsHeader: "Details",
  customerName: "Customer {{name}}",
  customerNameCardLabel: "Customer Name",
  customerType: "Type",
  customerTypeHeader: "Customer",
  detectedAt: "Detected at",
  displayRate: "Exchange Rate",
  edit: "Edit",
  expectedAmount: "Expected Amount",
  firstName: "First name",
  hostedAgreementUrl: "Hosted Agreement URL",
  lastName: "Last name",
  legalName: "Legal name",
  loading: "Loading...",
  network: "Network",
  networkFee: "Network Fee",
  notConfigured: "Not configured",
  onboarding: "Onboarding",
  onboardingRequired:
    "Onboarding must be completed before you can access this feature. Please complete the onboarding process first.",
  refundAlert: "This payment has been refunded.",
  refundAlreadyActive: "A refund is already in progress for this payment.",
  refundDialogDescription:
    "Are you sure you want to start a refund for this payment? This action will refund the full payment amount.",
  refundDialogTitle: "Start Refund",
  refundInfoHeader: "Refund",
  refundPayerEmail: "Payer Email",
  refundReason: "Reason (optional)",
  refundReasonLabel: "Reason",
  refundRequestedBy: "Requested By",
  refundStartButton: "Start Refund",
  refundStartedSuccess: "Refund started successfully.",
  refundStatusCancelled: "Cancelled",
  refundStatusCompleted: "Completed",
  refundStatusFailed: "Failed",
  refundStatusPending: "Pending",
  refundStatusProcessing: "Processing",
  refundStatusUnknown: "Unknown",
  save: "Save",
  selectCustomer: "Select a customer",
  selectCustomerDescription:
    "To view stablecoin features, please select a customer using the global filter.",
  stablecoins: "Stablecoins",
  stablecoinsPaymentDetails: "Payment Details",
  stablecoinsPaymentInfo: "Payment Info",
  stablecoinsPayments: "Payments",
  stablecoinsPaymentsCancelled: "Cancelled",
  stablecoinsPaymentsCompleted: "Completed",
  stablecoinsPaymentsExpired: "Expired",
  stablecoinsPaymentsFailed: "Failed",
  stablecoinsPaymentsNew: "New",
  stablecoinsPaymentsProcessing: "Processing",
  stablecoinsPaymentsStatusUnknown: "Unknown",
  stablecoinsPaymentsUnderpaid: "Underpaid",
  startOnboarding: "Start Onboarding",
  status: "Status",
  statusConfirmed: "Confirmed",
  statusDetected: "Detected",
  statusExpired: "Expired",
  statusFilled: "Filled",
  statusPending: "Pending",
  statusUnknown: "Unknown",
  stbAmount: "Amount",
  stbConfirmed: "Confirmed",
  stbCreatedAt: "Date (UTC)",
  stbCurrency: "CCY",
  stbExpiresAt: "Expires at",
  stbFiatPayment: "Fiat Payment",
  stbFiatPaymentSynced: "Fiat payment synced",
  stbNoPayments: "No payments",
  stbPaymentId: "Payment ID",
  stbPaymentSummary: "Stablecoins Payment Summary",
  stbRefunded: "Refunded",
  stbRefundedYes: "Yes",
  stbSearchByPaymentId: "Search by Payment ID",
  stbWeAreWaitingForYourFirstPayment:
    "We're waiting for your first stablecoin payment",
  token: "Token",
  transactionDetails: "Transaction Details",
  txDetails: "Tx Details",
  txHash: "Tx Hash",
  view: "View",
  vx2ProductDisabled: "VX2 product is not enabled",
  vx2ProductDisabledDescription: "Please contact sales to enable this feature.",
  walletAddress: "Wallet Address",
};
